import {getInitialState} from '../../helpers/initial-state'
import {useEnabledFeatures} from '../../hooks/use-enabled-features'

export function useIssueFieldsEnabled() {
  const {issue_fields} = useEnabledFeatures()
  const {isOrganization} = getInitialState()
  return Boolean(issue_fields && isOrganization)
}
